import { AlertTriangle, Globe, RefreshCw } from 'lucide-react';
import { useWordpressSummary } from '../hooks/useWordpress';
import { SiteSummaryCard } from '../components/wordpress/SiteSummaryCard';
import { Card } from '../components/ui/Card';
import { Spinner } from '../components/ui/Spinner';
import { getApiErrorMessage, isApiError } from '../api/client';
import { formatRelativeTime } from '../utils/format';
import { ComingSoon } from './ComingSoon';

export function Sites() {
  const { data, isLoading, isFetching, isError, error, refetch } = useWordpressSummary();

  if (isLoading) {
    return (
      <div className="flex h-96 items-center justify-center">
        <Spinner size={28} />
      </div>
    );
  }

  if (isApiError(error) && error.response.status === 503) {
    return <ComingSoon icon={Globe} title="Sites" integrationLabel="WordPress" />;
  }

  if (isError || !data) {
    return (
      <Card className="p-8 text-center">
        <AlertTriangle className="mx-auto mb-3 text-rose-500" size={28} />
        <p className="font-medium text-slate-700 dark:text-slate-200">Couldn&apos;t load WordPress data</p>
        <p className="mt-1 text-sm text-slate-400">{getApiErrorMessage(error)}</p>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-sm text-slate-400">
          {data.sites.length} site{data.sites.length === 1 ? '' : 's'} &middot; updated {formatRelativeTime(data.fetchedAt)}
        </p>
        <button
          onClick={() => refetch()}
          className="flex items-center gap-1.5 text-sm font-medium text-pulse-600 hover:text-pulse-700 dark:text-pulse-400"
        >
          <RefreshCw size={14} className={isFetching ? 'animate-spin' : ''} />
          Refresh
        </button>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        {data.sites.map((site) => (
          <SiteSummaryCard key={site.key} site={site} />
        ))}
      </div>
    </div>
  );
}
